export default __webpack_public_path__ + "static/media/hello-beautiful@2x.346222ce.png";